// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d303483f","223":"5838f1f6","321":"c3fcd5dd","433":"85e78449","573":"37d6290f","830":"f5764779"}[chunkId] + ".chunk.js";
};